import React from 'react';
import cx from 'classnames';
import { func, bool, oneOfType, string, number, node } from 'prop-types';

import s from './index.module.css';

const RadioButton = ({ value, onChange, className, isChecked, children, name, theme, isRed }) => (
  <label
    className={cx(s.radioWrapper, {
      [className]: !!className,
      [s.radioWrapperChecked]: isChecked,
      [s.noBorderThemeWrapper]: theme === 'noBorderTheme',
      [s.redOption]: isRed,
    })}
  >
    <input
      className={cx(s.radioInput, { [s.noBorderThemeInput]: theme === 'noBorderTheme' })}
      value={value}
      checked={isChecked}
      onChange={() => onChange(value)}
      type="radio"
      name={name}
    />
    <div className={cx(s.content, { [s.noBorderThemeContent]: theme === 'noBorderTheme' })}>{children}</div>
  </label>
);

RadioButton.propTypes = {
  children: node,
  className: string,
  onChange: func,
  isChecked: bool,
  value: oneOfType([string, number]),
  name: string,
};

RadioButton.defaultProps = {
  onChange: () => {},
};

export default RadioButton;
